import axios from 'axios'
import router from './../../router';

const state = {
    status: '',
    //token: localStorage.getItem('token') || '',
    user: JSON.parse(localStorage.getItem('user')) || ''
}
const getters = {
    isLoggedIn (state) {
        return !!state.user.token
    },
    authStatus (state) {
        return state.status
    }
}
const actions = {
    /* getUser ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
        axios({url: '/api/user', method: 'GET' })
            .then(resp => {
                if (!resp.data.user) {
                    dispatch('logout')
                } else {
                    commit('user_set', {email: resp.data.user.email})
                }
                resolve(resp)
            })
            .catch(err => {
                dispatch('logout')
                reject(err)
            })
    })
}, */
    logout ({ commit }) {
        return new Promise((resolve) => {
            commit('logout')
            localStorage.removeItem('user')
            delete axios.defaults.headers.common['Authorization']
            router.push('/login')
            resolve()
        })
    },
}
const mutations = {
    auth_request (state) {
        state.status = 'loading'
    },
    auth_success (state, user) {
        state.status = 'success'
        state.user = user
        localStorage.setItem('user', JSON.stringify(user))
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.token
    },
    auth_error (state) {
        state.status = 'error'
    },
    logout (state) {
        state.status = ''
        state.user = ''
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}